export const IN_SLA = '0';
export const BREACHED = '1';
export const SLA_WARNING = '2';
export const RESOLVED_IN_SLA = '3';
export const RESOLVED_OUT_OF_SLA = '4';
export const FIRST_RESPONSE_SLA = 'FIRST_RESPONSE_SLA';
export const CLOSE_TICKET_SLA = 'CLOSE_TICKET_SLA';
export const NEXT_RESPONSE_SLA = 'NEXT_RESPONSE_SLA';